import React from 'react';

import {
    withInterstitial,
} from 'wanderu-component-page-loader';
import {
    ScrollToTopOnMount,
} from 'wanderu-hocs';

function onLoad(module, ...args) {
    module.onLoad(module, ...args);
}

const StationGuidePage = withInterstitial(import('./pages/StationGuidePage'), { onLoad });

export default [
    {
        path: '/stations/:station',
        key: 'stationGuide',
        component: ScrollToTopOnMount(StationGuidePage),
        exact: true,
    },
];
